import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { loginBO, OnboardingCredential } from './onboarding.model';
import { ErrorService } from 'src/app/error.service';

@Injectable({
    providedIn: 'root'
})
export class onboardingservice {
    constructor(private http: HttpClient, public errorService: ErrorService) { }
    registerJobPortal(saveJob: OnboardingCredential): Observable<any> {
        let url = "api/OnboardLogin/SaveOnboardAccount";
        return this.http.post<any>(url, saveJob, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
    loginportal(saveJob: loginBO): Observable<any> {
        let url = "api/Auth/login";
        return this.http.post<any>(url, saveJob, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }

    // .........................................forgotpasswordclient..................................................//
    forgotPasswordclient(paramsData: URLSearchParams): Observable<any> {
        let url = "api/Auth/forgotPassword?";
        return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }

    OnboardLoginAuthentication(LoginPayLoad: loginBO): Observable<any> {
        let url = "api/Auth/login";
        return this.http.post<any>(url, LoginPayLoad, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }

    // For Client Onboarding Side Menus
    getsideMenuforClientOnboarding(): Observable<any> {
        let Clientsidemenudatas = [
            {
                "id": 2,
                "title": "Participant Agreement",
                "routerLink": "/client-onboarding-list",
                "href": null,
                "icon": "users",
                "target": null,
                "hasSubMenu": false,
                "parentId": 0,
            },
            {
                "id": 3,
                "title": "Employee Agreement",
                "routerLink": "/employee-agreementlist",
                "href": null,
                "icon": "users",
                "target": null,
                "hasSubMenu": false,
                "parentId": 0,
            },
            {
                "id": 4,
                "title": "Budget Plan",
                "routerLink": "/budgetimport",
                "href": null,
                "icon": "money",
                "target": null,
                "hasSubMenu": false,
                "parentId": 0,
            }
            ,
            {
                "id": 5,
                "title": "Purchase Request",
                "routerLink": "/purchase-list",
                "href": null,
                "icon": "money",
                "target": null,
                "hasSubMenu": false,
                "parentId": 0,
            },
            {
                "id": 6,
                "title": "Handbook",
                "routerLink": "/handbook",
                "href": null,
                "icon": "book",
                "target": null,
                "hasSubMenu": false,
                "parentId": 0,
            },
        ];
        return of(Clientsidemenudatas);
    }

    // For Employee Onboarding Side Menus
    getsideMenuforEmployeeOnboarding(): Observable<any> {

        let Employeesidemenudatas = [
            {
                "id": 2,
                "title": "Employee Agreement",
                "routerLink": "/employee-agreementlist",
                "href": null,
                "icon": "users",
                "target": null,
                "children": null,
                "parentId": 0,
            },
            {
                "id": 3,
                "title": "Handbook",
                "routerLink": "/handbook",
                "href": null,
                "icon": "book",
                "target": null,
                "children": null,
                "parentId": 0,
            },


        ]
        return of(Employeesidemenudatas);
    }





}